<template>
  <div class="main">
    <AllHeader title="审计报告"></AllHeader>
    <InfoList fenlei="审计报告"></InfoList>
  </div>
</template>
<script>
import AllHeader from "@/components/AllHeader.vue";
import InfoList from "@/components/InfoList.vue";
export default {
  data() {
    return {};
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {},
  components: {
    AllHeader,
    InfoList
  }
};
</script>
<style lang="less" scoped>
.main {
  margin-top: 20px;
  width: 100%;
  .wrapper {
    width: 95%;
    margin: 30px auto;
    .content {
      width: 100%;
      line-height: 1.5;
      color: #000;
    }
  }
}
</style>